import {useQuery} from 'react-query'
import {MonthlyreportEditModalForm} from './MonthlyreportEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
import { getMonthlyreportById } from '../core/_requests'
// import { getMonthlyreportById } from '../../../apps/monthlyreport-management/monthlyreports-list/core/_requests'
// import {getMonthlyreportById} from '../core/_requests'

const MonthlyreportEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: monthlyreport,
    error,
  } = useQuery(
    `${QUERIES.MONTHLYREPORTS_LIST}-monthlyreport-${itemIdForUpdate}`,
    () => {
      return getMonthlyreportById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <MonthlyreportEditModalForm isMonthlyreportLoading={isLoading} monthlyreport={{id: undefined}} />
  }

  if (!isLoading && !error && monthlyreport) {
    return <MonthlyreportEditModalForm isMonthlyreportLoading={isLoading} monthlyreport={monthlyreport} />
  }

  return null
}

export {MonthlyreportEditModalFormWrapper}
